// Translates errors into the UI's own voice. Errors crossing the worker
// boundary arrive as plain Error objects with the original message but not
// the original class (postMessage can't clone a custom Error subclass), so
// we match on message text from lib/errors.ts instead of instanceof.
const INVALID_PASSWORD_MESSAGE = "Decryption failed: invalid password or corrupted data";

export function humanizeDecryptFileError(e: unknown): string {
  if (e instanceof Error && e.message === INVALID_PASSWORD_MESSAGE) {
    return "That password didn't unlock this file. Try another.";
  }
  return humanizeGeneric(e, "Decrypting that file didn't work.");
}

export function humanizeDecryptFileForRecipientError(e: unknown): string {
  if (e instanceof Error && e.message === INVALID_PASSWORD_MESSAGE) {
    return "That envelope didn't open with your currently active key. Make sure you have the right key unlocked and the matching envelope.";
  }
  return humanizeGeneric(e, "Opening that shared file didn't work.");
}

export function humanizeDecryptStringError(e: unknown): string {
  if (e instanceof Error && e.message === INVALID_PASSWORD_MESSAGE) {
    return "That password didn't unlock this message. Try another.";
  }
  return humanizeGeneric(e, "Decrypting that message didn't work.");
}

export function humanizeGeneric(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message && e.message !== "Operation failed") {
    return e.message;
  }
  return fallback;
}
